<template>
    <div>
        <v-card class="pa-3 mt-3" color="#0e1439" dark>
            <v-card-title class="pb-2">
                <v-icon left>mdi-cog-outline</v-icon>
                Detalhes dos Serviços Complementares
            </v-card-title>
            
            <div v-for="(ssu, index) in ssuOrders" :key="ssu.id">
                <v-divider v-if="index > 0" class="my-3"></v-divider>
                
                <div class="ssu-item d-flex">
                    <div class="ssu-counter">
                        {{ index + 1 }}/{{ ssuOrders.length }}
                    </div>
                    <table width="100%" class="white--text">
                        <tr>
                            <th align="right" width="30%">Serviço complementar:</th>
                            <td>{{ ssu.snap.name }}</td>
                            <th align="right" width="20%">
                                <v-btn 
                                    x-small 
                                    outlined 
                                    color="white" 
                                    @click="openDetailsDialog(ssu)"
                                >
                                    Ver Detalhes
                                    <v-icon x-small right>mdi-information-outline</v-icon>
                                </v-btn>
                            </th>
                        </tr>
                        
                        <tr>
                            <th align="right">Tipo de serviço:</th>
                            <td colspan="2">{{ getServiceType(ssu.type) }}</td>
                        </tr>
                        
                        <tr>
                            <th align="right">Status do serviço:</th>
                            <td colspan="2">
                                <v-chip :color="getStatusColor(ssu.status, expired)" :dark="false" class="black--text" small>
                                    {{ getStatusText(ssu.status, expired) }}
                                </v-chip>
                            </td>
                        </tr>
                        
                        <tr>
                            <th align="right">Valor unitário (líquido):</th>
                            <td colspan="2">
                                {{ $n(ssu.unityPrice * 0.8, 'currency') }}
                            
                            </td>
                        </tr>
                        
                        <tr>
                            <th align="right">Quantidade do pedido:</th>
                            <td colspan="2">{{ ssu.totalQuantity }}</td>
                        </tr>
                        
                        <tr>
                            <th align="right">Valor total:</th>
                            <td colspan="2">
                                <strong>{{ $n(ssu.totalPrice * 0.8, 'currency') }}</strong>
                            </td>
                        </tr>
                        
                        <tr>
                            <th align="right" style="border-top: 1px solid rgba(255,255,255,0.3); padding-top: 10px; vertical-align: top; padding-top: 22px;">
                                Comentário:
                            </th>
                            <td colspan="2" style="border-top: 1px solid rgba(255,255,255,0.3); padding-top: 10px;">
                                <div class="d-flex align-start mt-2" style="gap: 12px;">
                                    <v-textarea
                                        v-model="ssu.comment"
                                        :disabled="expired === true || !isExecutive || (DEBUG_MODE_ENABLE_BUTTONS ? false : (ssu.status === 18 || ssu.status === 13))"
                                        color="white"
                                        hide-details
                                        outlined
                                        dense
                                        dark
                                        rows="3"
                                        no-resize
                                        label="Deixe um comentário..."
                                        style="flex: 1;"
                                    ></v-textarea>
                                    <v-btn
                                        color="primary"
                                        :disabled="expired === true || !isExecutive || !ssu.comment || (DEBUG_MODE_ENABLE_BUTTONS ? false : (ssu.status === 18 || ssu.status === 13))"
                                        :loading="ssu.loadingComment"
                                        @click="sendComment(ssu)"
                                        style="margin-top: 4px;"
                                    >
                                        <v-icon left small>mdi-send</v-icon>
                                        Enviar
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                        
                        <tr>
                            <th align="right">Valor final:</th>
                            <td colspan="2">
                                <div class="d-flex align-center justify-space-between">
                                    <div>
                                        <strong class="text-h6">{{ $n(ssu.finalPrice * 0.8, 'currency') }}</strong>
                                    </div>
                                    <div>
                                        <v-tooltip bottom :disabled="expired !== true && ssu.status !== 18 && ssu.status !== 13">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" style="display: inline-block;">
                                                    <v-btn
                                                        small
                                                        color="success"
                                                        class="mr-2"
                                                        :disabled="expired === true || !isExecutive || (DEBUG_MODE_ENABLE_BUTTONS ? false : (ssu.status === 18 || ssu.status === 13))"
                                                        :loading="ssu.loadingConfirm"
                                                        @click="openConfirmDialog(ssu)"
                                                    >
                                                        <v-icon small left>mdi-check</v-icon>
                                                        Confirmar
                                                    </v-btn>
                                                </div>
                                            </template>
                                            <span v-if="expired === true">Esta cotação foi cancelada por falta de resposta</span>
                                            <span v-else-if="ssu.status === 18">Este serviço está aguardando aprovação do cliente</span>
                                            <span v-else-if="ssu.status === 13">Este serviço foi cancelado</span>
                                        </v-tooltip>
                                        <v-tooltip bottom :disabled="expired !== true && ssu.status !== 18 && ssu.status !== 13">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" style="display: inline-block;">
                                                    <v-btn
                                                        small
                                                        color="error"
                                                        outlined
                                                        :disabled="expired === true || !isExecutive || (DEBUG_MODE_ENABLE_BUTTONS ? false : (ssu.status === 18 || ssu.status === 13))"
                                                        :loading="ssu.loadingReject"
                                                        @click="openRejectDialog(ssu)"
                                                    >
                                                        <v-icon small left>mdi-close</v-icon>
                                                        Rejeitar
                                                    </v-btn>
                                                </div>
                                            </template>
                                            <span v-if="expired === true">Esta cotação foi cancelada por falta de resposta</span>
                                            <span v-else-if="ssu.status === 18">Este serviço está aguardando aprovação</span>
                                            <span v-else-if="ssu.status === 13">Este serviço foi cancelado</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="detailsDialog.show" max-width="800" persistent>
            <v-card v-if="detailsDialog.ssu">
                <v-card-title class="primary white--text d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                        <v-icon left color="white">mdi-information-outline</v-icon>
                        <span>Detalhes do serviço em cotação</span>
                    </div>
                    <v-btn icon color="black" @click="detailsDialog.show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                
                <v-divider></v-divider>
                
                <v-card-text class="pa-6">
                    <v-list class="transparent">
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold mb-1">Serviço complementar</v-list-item-subtitle>
                                <v-list-item-title class="text-body-1">{{ detailsDialog.ssu.snap?.name || 'NOME DO SERVIÇO' }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-divider class="my-2"></v-divider>
                        
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold mb-1">Tipo de serviço</v-list-item-subtitle>
                                <v-list-item-title class="text-body-1">{{ getServiceCategory(detailsDialog.ssu.snap?.category) }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-divider class="my-2"></v-divider>
                        
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold mb-1">Código de referência</v-list-item-subtitle>
                                <v-list-item-title class="text-body-1">{{ detailsDialog.ssu.snap?.providerProductCode || 'CÓDIGO DO FORNECEDOR' }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-divider class="my-2"></v-divider>
                        
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold mb-1">Descrição</v-list-item-subtitle>
                                <div class="text-body-2" v-html="detailsDialog.ssu.snap?.description || 'DESCRIÇÃO PARA O USUÁRIO'"></div>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-divider class="my-2"></v-divider>
                        
                        <v-list-item class="px-0">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold mb-1">Especificações</v-list-item-subtitle>
                                <div class="text-body-2" v-html="detailsDialog.ssu.snap?.specifications || 'ESPECIFICAÇÕES DE PRODUÇÃO'"></div>
                            </v-list-item-content>
                        </v-list-item>
                        
                        <v-divider class="my-3"></v-divider>
                        
                        <v-row class="px-3">
                            <v-col cols="12" md="6">
                                <div class="detail-item">
                                    <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">Tempo de produção</div>
                                    <div class="text-body-1">
                                        <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                                        {{ getBookingTime(detailsDialog.ssu, 'duration') }}
                                    </div>
                                </div>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <div class="detail-item">
                                    <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">Tempo de instalação</div>
                                    <div class="text-body-1">
                                        <v-icon small color="primary" class="mr-1">mdi-wrench-clock</v-icon>
                                        {{ getBookingTime(detailsDialog.ssu, 'installation') }}
                                    </div>
                                </div>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <div class="detail-item">
                                    <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">Prazo de entrega</div>
                                    <div class="text-body-1">
                                        <v-icon small color="primary" class="mr-1">mdi-truck-delivery</v-icon>
                                        {{ getBookingTime(detailsDialog.ssu, 'production') }}
                                    </div>
                                </div>
                            </v-col>
                            
                            <v-col cols="12" md="6">
                                <div class="detail-item">
                                    <div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">Durabilidade prevista</div>
                                    <div class="text-body-1">
                                        <v-icon small color="primary" class="mr-1">mdi-calendar-check</v-icon>
                                        {{ getBookingTime(detailsDialog.ssu, 'durability') }}
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        
                        <v-divider class="my-3"></v-divider>
                        
                        <v-list-item class="px-0 primary lighten-5">
                            <v-list-item-content>
                                <v-list-item-subtitle class="text-caption font-weight-bold primary--text mb-1">Valor unitário</v-list-item-subtitle>
                                <v-list-item-title class="text-h6 primary--text">
                                    {{ $n(detailsDialog.ssu.unityPrice || 0, 'currency') }} 
                                    <span class="text-body-2">{{ detailsDialog.ssu.snap?.pricing_policy?.label || '' }}</span>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                
                <v-divider></v-divider>
                
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="detailsDialog.show = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDialog.show" max-width="670">
            <v-card>
                <v-card-title class="text-h6">
                    Confirmar serviço
                </v-card-title>
                <v-card-text>
                    Esta ação não poderá ser desfeita. Deseja realmente confirmar este serviço?
                    <v-alert type="info" text dense class="mt-3 mb-0">
                        Ao realizar essa ação sua resposta será aplicada a todos os serviços iguais a esse
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmDialog.show = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" @click="confirmAction">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rejectDialog.show" max-width="670">
            <v-card>
                <v-card-title class="text-h6">
                    Rejeitar serviço
                </v-card-title>
                <v-card-text>
                    Esta ação não poderá ser desfeita. Deseja realmente rejeitar este serviço?
                    <v-alert type="info" text dense class="mt-3 mb-0">
                        Ao realizar essa ação sua resposta será aplicada a todos os serviços iguais a esse
                    </v-alert>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="rejectDialog.show = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="error" @click="rejectAction">
                        Rejeitar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { showSuccess, showError, showInfo } from '@/plugins/snackbar-helper'

export default {
    name: 'QuotationSsuOrder',
    props: {
        ssuOrders: {
            type: Array,
            required: true
        },
        isExecutive: {
            type: Boolean,
            default: false
        },
        expired: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            DEBUG_MODE_ENABLE_BUTTONS: false,
            
            customTokens: {
                '#': { pattern: /\d/, optional: true },
                '0': { pattern: /\d/ }
            },
            money: {
                decimal: ",",
                thousands: ".",
                prefix: "",
                suffix: "",
                precision: 2,
                unmaskedVar: "rawPrice"
            },
            detailsDialog: {
                show: false,
                ssu: null
            },
            confirmDialog: {
                show: false,
                ssu: null
            },
            rejectDialog: {
                show: false,
                ssu: null
            }
        }
    },
    mounted() {
        this.initializeSsuData()
    },
    methods: {
        initializeSsuData() {
            this.ssuOrders.forEach(ssu => {
                this.$set(ssu, 'invertDiscount', false)
                const initialDiscount = (ssu.discount && parseFloat(ssu.discount) > 0) ? parseFloat(ssu.discount) : (ssu.percentDiscount || 0)
                this.$set(ssu, 'discountPercent', initialDiscount)
                const discountAmount = ssu.totalPrice * (initialDiscount / 100)
                this.$set(ssu, 'discountValue', discountAmount.toFixed(2))
                this.$set(ssu, 'finalPrice', ssu.totalPrice - discountAmount)
                
                this.$set(ssu, 'loadingConfirm', false)
                this.$set(ssu, 'loadingReject', false)
                this.$set(ssu, 'comment', '')
                this.$set(ssu, 'loadingComment', false)
            })
        },
        openDetailsDialog(ssu) {
            this.detailsDialog.ssu = ssu
            this.detailsDialog.show = true
        },
        openConfirmDialog(ssu) {
            this.confirmDialog.ssu = ssu
            this.confirmDialog.show = true
        },
        openRejectDialog(ssu) {
            this.rejectDialog.ssu = ssu
            this.rejectDialog.show = true
        },
        confirmAction() {
            this.confirmDialog.show = false
            this.confirmSsu(this.confirmDialog.ssu)
        },
        rejectAction() {
            this.rejectDialog.show = false
            this.rejectSsu(this.rejectDialog.ssu)
        },
        sendComment(ssu) {
            if (!ssu.comment) return
            ssu.loadingComment = true
            this.$axios.post(`/grids/complementary-service/notification`, {
                comment: ssu.comment,
                gridId: ssu.gridId,
                userName: this.$root.auth.user.name,
                complementaryName: ssu.snap.name,
                serviceType: this.getServiceType(ssu.type)
            })
                .then(() => {
                    ssu.loadingComment = false
                    ssu.comment = ''
                    showSuccess('Comentário enviado com sucesso!')
                })
                .catch((err) => {
                    ssu.loadingComment = false
                    showError('Erro ao enviar comentário. Tente novamente.')
                    console.error('Erro ao enviar comentário:', err)
                })
        },
        getServiceType(type) {
            const types = {
                'creation': 'Criação',
                'production_installation_and_removal': 'Produção/Instalação/Remoção',
                'production': 'Produção',
                'installation': 'Instalação',
                'removal': 'Remoção',
                'material_production': 'Produção de Material',
                'maintenance_and_repair': 'Manutenção e Reparo',
                'logistics': 'Logística',
                'other': 'Outro'
            }
            return types[type] || type || 'N/D'
        },
        getServiceCategory(category) {
            const categories = {
                1: 'Criação',
                2: 'Produção',
                3: 'Instalação',
                4: 'Remoção',
                5: 'Manutenção',
                6: 'Logística',
                7: 'Outro'
            }
            return categories[category] || 'CATEGORIA'
        },
        getBookingTime(ssu, field) {
            const bookingDays = ssu.snap?.general_policies?.booking_days
            if (!bookingDays || !bookingDays[field]) {
                return 'TEMPO_' + field.toUpperCase()
            }
            
            const value = bookingDays[field].value
            const type = bookingDays[field].type
            
            if (!value) {
                return 'N/D'
            }
            
            return `${value} ${type || ''}`
        },
        calculateSsuDiscount(ssu, type) {
            if (type === 'percent') {
                const percent = parseFloat(ssu.discountPercent) || 0
                const discountAmount = ssu.totalPrice * (percent / 100)
                ssu.discountValue = discountAmount.toFixed(2)
                ssu.finalPrice = ssu.totalPrice - discountAmount
            } else {
                const value = parseFloat(ssu.discountValue.toString().replace(/\./g, '').replace(',', '.')) || 0
                ssu.discountPercent = ((value / ssu.totalPrice) * 100).toFixed(2)
                ssu.finalPrice = ssu.totalPrice - value
            }
        },
        checkSsuPercent(ssu) {
            let value = parseFloat(ssu.discountPercent) || 0
            if (value > 100) ssu.discountPercent = 100
            if (value < 0) ssu.discountPercent = 0
        },
        checkSsuValue(ssu) {
            let value = parseFloat(ssu.discountValue.toString().replace(/\./g, '').replace(',', '.')) || 0
            if (value > ssu.totalPrice) ssu.discountValue = ssu.totalPrice.toFixed(2)
            if (value < 0) ssu.discountValue = 0
        },
        confirmSsu(ssu) {
            ssu.loadingConfirm = true
            
            const payload = {
                id: ssu._id || ssu.id
            }
            
            const hasDiscount = parseFloat(ssu.discountPercent) > 0
            
            if (hasDiscount) {
                payload.discount = parseFloat(ssu.discountPercent)
            }
            
            let observation = hasDiscount 
                ? `Concedemos ${ssu.discountPercent}% de desconto sobre o valor de tabela.`
                : 'Nenhum desconto concedido.'
            
            payload.observation = observation
            
            this.$axios.put(`/portal/request/ssu/quotation/${ssu.orderSyncId}`, payload)
                .then((response) => {
                    ssu.loadingConfirm = false
                    showSuccess('Serviço aprovado com sucesso!')
                    this.$emit('refresh')
                })
                .catch((err) => {
                    ssu.loadingConfirm = false
                    showError('Erro ao processar serviço. Tente novamente.')
                    console.error('Erro ao atualizar serviço:', err)
                })
        },
        rejectSsu(ssu) {
            ssu.loadingReject = true
            
            const payload = {
                id: ssu._id || ssu.id,
                status: 13,
                observation: 'Serviço rejeitado pelo publisher'
            }
            
            this.$axios.put(`/portal/request/ssu/quotation/${ssu.orderSyncId}`, payload)
                .then((response) => {
                    ssu.loadingReject = false
                    showInfo('Serviço cancelado com sucesso!')
                    this.$emit('refresh')
                })
                .catch((err) => {
                    ssu.loadingReject = false
                    showError('Erro ao processar serviço. Tente novamente.')
                    console.error('Erro ao atualizar serviço:', err)
                })
        },
        getStatusText(statusId, expired) {
            // Se está expirado e o status está entre 14-24, mostra mensagem de cancelamento
            if (expired === true && statusId >= 14 && statusId <= 24) {
                return 'Cancelada por falta de resposta'
            }
            
            const statusMap = {
                13: 'Pedido cancelado',
                14: 'Em planejamento',
                15: 'Resposta de cotação pendente',
                16: 'Aguardando confirmação',
                17: 'Pedido rejeitado',
                18: 'Aguardando aprovação do cliente',
                19: 'Aguardando pagamento',
                20: 'Aguardando pagamento',
                21: 'Aguardando envio do conteúdo',
                22: 'Pendente aprovação de conteúdo',
                23: 'Aguardando adequação de conteúdo',
                24: 'Aguardando início de veiculação',
                25: 'Em veiculação',
                26: 'Falha na veiculação',
                27: 'Veiculação concluída'
            }
            return statusMap[statusId] || `Status ${statusId}`
        },
        getStatusColor(statusId, expired) {
            // Se está expirado e o status está entre 14-24, retorna vermelho
            if (expired === true && statusId >= 14 && statusId <= 24) {
                return '#dc3545'
            }
            
            const colorMap = {
                13: '#dc3545',
                14: '#FFFF00',
                15: '#FFFF00',
                16: '#FFFF00',
                17: '#dc3545',
                18: '#ff8c00',
                19: '#ff8c00',
                20: '#ff8c00',
                21: '#ff8c00',
                22: '#FFFF00',
                23: '#dc3545',
                24: '#17a2b8',
                25: '#28a745',
                26: '#FFFF00',
                27: '#28a745'
            }
            return colorMap[statusId] || '#999999'
        }
    }
}
</script>

<style scoped lang="scss">
.ssu-item {
    position: relative;
    
    .ssu-counter {
        font-size: 0.875rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.7);
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 30px;
    }
    
    table {
        td, th {
            padding: 8px 12px;
            font-size: 0.875rem;
        }
        
        th {
            font-weight: 600;
            opacity: 0.9;
        }
    }
}

.detail-item {
    padding: 12px;
    border-radius: 8px;
    background-color: #f5f5f5;
    height: 100%;
}

::v-deep {
    .v-text-field--outlined fieldset {
        border-color: rgba(255, 255, 255, 0.5) !important;
    }
    
    .v-text-field input {
        color: white !important;
    }
    
    .v-label {
        color: rgba(255, 255, 255, 0.7) !important;
    }
    
    .v-list-item__content {
        padding: 8px 0;
    }
    
    .v-list-item__title {
        white-space: normal;
        line-height: 1.5;
    }
}
</style>
